import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, Typography, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';

const VERSION = process.env.REACT_APP_VERSION || '';

// ==============================|| SIDEBAR DRAWER ||============================== //
// Soft Tone：蜜桃浅侧栏（ofox 气质），选中为白底墨金

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const navBody = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <LogoSection />
        </Box>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <BrowserView>
          <PerfectScrollbar
            component="div"
            style={{
              height: !matchUpMd ? 'calc(100vh - 56px - 88px)' : 'calc(100vh - 88px - 88px)',
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 8
            }}
          >
            <Typography
              sx={{
                px: 1.5,
                mb: 1,
                fontSize: 10.5,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: '#A8A29E',
                fontWeight: 600
              }}
            >
              Navigation
            </Typography>
            <MenuList />
          </PerfectScrollbar>
        </BrowserView>
        <MobileView>
          <Box sx={{ px: 1.5, pt: 1, flex: 1, overflow: 'auto' }}>
            <MenuList />
          </Box>
        </MobileView>
      </Box>

      <Box
        sx={{
          flexShrink: 0,
          px: 1.5,
          pt: 1,
          pb: 1.5,
          borderTop: '1px solid rgba(28,25,23,0.08)',
          background: 'transparent'
        }}
      >
        <MenuCard />
        {VERSION ? (
          <Typography
            sx={{
              mt: 0.75,
              px: 0.5,
              fontSize: 10,
              color: '#A8A29E',
              letterSpacing: '0.02em',
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace'
            }}
          >
            {VERSION}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: '#F3EDE4',
            color: '#44403C',
            borderRight: '1px solid rgba(28,25,23,0.06)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            '& .MuiListItemButton-root': {
              color: '#78716C !important',
              borderRadius: '999px !important',
              mx: 0,
              position: 'relative',
              transition: 'background .18s ease, color .18s ease'
            },
            '& .MuiListItemButton-root:hover': {
              background: 'rgba(255,255,255,0.55) !important',
              color: '#1C1917 !important'
            },
            '& .MuiListItemButton-root .MuiTypography-root': { color: 'inherit !important', fontWeight: 500 },
            '& .MuiListItemIcon-root': { color: '#A8A29E !important', minWidth: '36px !important' },
            '& .MuiListItemButton-root.Mui-selected': {
              background: '#FFFFFF !important',
              color: '#8B6520 !important',
              boxShadow: '0 0 0 1px rgba(201,168,76,0.28)'
            },
            '& .MuiListItemButton-root.Mui-selected:hover': {
              background: '#FFFFFF !important'
            },
            '& .MuiListItemButton-root.Mui-selected .MuiListItemIcon-root': { color: '#C9A84C !important' },
            '& .MuiListItemButton-root.Mui-selected .MuiTypography-root': { color: '#8B6520 !important', fontWeight: 650 },
            '& .MuiTypography-caption': { color: '#A8A29E !important' },
            '& .MuiDivider-root': { borderColor: 'rgba(28,25,23,0.08)' },
            [theme.breakpoints.up('md')]: {
              top: '88px'
            }
          }
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {navBody}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
